import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option: "a) Gerenciamento de Contas In-app banking.",
    correct: false,
  },
  {
    option: "b) Gerenciamento de Contas Voice assistant.",
    correct: true,
  },
  {
    option: "c) Assessoria Inteligente in-app banking.",
    correct: false,
  },
  {
    option: "d) Assistente Virtual de Onboarding WhatsApp Chatbots.",
    correct: false,
  },
  {
    option:
      "e) Solução de segurança avançada para transações bancárias online.",
    correct: false,
  },
];

export default function Question23(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question23: {
          title:
            "Qual serviço oferecido pela Topaz no contexto da revolução do atendimento bancário digital destaca-se por permitir aos clientes resolver problemas utilizando comandos de voz?",
          option: option.option,
          correct: option.correct,
          order: 23
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        {t(
          "Qual serviço oferecido pela Topaz no contexto da revolução do atendimento bancário digital destaca-se por permitir aos clientes resolver problemas utilizando comandos de voz?"
        )}
      </h5>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
